/* eslint-disable max-len */
import React from 'react';

const ShortcutIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.5 6v5.5H18v1h-5.5V18h-1v-5.5H6v-1h5.5V6h1z"
    />
  </svg>
);

export default ShortcutIcon;
